import { useMutation } from 'react-query';
import { activeDirectory, token } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';

import { useProjectTreeStore } from 'store/projectContract.store';

import { switchUser as mutationFn } from 'api/endPoints/switchUser';
import { TMfaType } from 'api/queries/getUserDetail.query';

export const useMutationSwitchUser = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) =>
            mutationFn(params).then((response) => {
                const update = useProjectTreeStore.getState().update;
                token.set(response.accessToken);
                network.defaults.headers.common['Authorization'] = `Bearer ${response.accessToken}`;
                activeDirectory.set(
                    window['ENV_VARIABLES']
                        ? window['ENV_VARIABLES']['REACT_APP_ACTIVE_DIRECTORY_URL']
                        : activeDirectory.get(),
                );
                update({ project: null, contract: null, parentNode: null, currentList: [] });
                return response;
            }),
    });
};

interface QueryParams {
    userName: string;
}

interface QueryResponse {
    accessToken: string;
    customerId: null;
    defaultProjectId: number;
    email: string;
    mfa: TMfaType;
    phone: null;
    tokenType: 'Bearer';
}
